import React, { useEffect, useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
  ChartDataLabels
);

const ChartNew = ({ chartData }) => {
  const chartRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    const ctx = chart.ctx;
    const tiers = chartData.labels;
    const gradients = [];

    tiers.forEach((tier) => {
      const gradient = ctx.createLinearGradient(0, chart.height, 0, 0);

      let baseColor;
      if (tier.toLowerCase().includes("bronze")) {
        baseColor = "#cd7f32";
      } else if (tier.toLowerCase().includes("silver")) {
        baseColor = "#dcdcdc";
      } else if (tier.toLowerCase().includes("gold")) {
        baseColor = "#ffd700";
      } else if (tier.toLowerCase().includes("platinum")) {
        baseColor = "#e5e4e2";
      } else {
        baseColor = "#90cdf4";
      }

      gradient.addColorStop(0, baseColor);
      gradient.addColorStop(0.8, "rgba(232, 222, 246, 0.8)");
      gradient.addColorStop(1, "rgba(245, 242, 250, 0.8)");

      gradients.push(gradient);
    });

    chart.data.datasets[0].backgroundColor = gradients;
    chart.update();
  }, [chartData]);

  const calculateBarThickness = () => {
    const containerWidth = containerRef.current?.offsetWidth || 0;
    return Math.min(40, Math.max(20, containerWidth / 15));
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    barThickness: 'flex',
    maxBarThickness: calculateBarThickness(),
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: "end",
        align: "start",
        offset: -20,
        color: "#000",
        font: { 
          weight: "bold", 
          size: 14
        },
        formatter: function(value) {
          return value;
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          font: {
            size: 14,
            weight: "bold"
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#eee",
          borderDash: [4],
        },
        ticks: {
          font: {
            size: 12
          },
          stepSize: 14,
          display: false,
        },
      },
    },
  };

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        minHeight: "250px",
        background: "#fff",
        borderRadius: "8px",
        padding: "50px",
        border: "2px solid #3498db",
      }}
    >
      <div style={{ 
        position: "relative", 
        width: "100%", 
        height: "100%",
        minHeight: "200px"
      }}>
        <Bar 
          ref={chartRef} 
          data={chartData} 
          options={options}
        />
      </div>
    </div>
  );
};

export default ChartNew;